<ag-modal-base>
  <!--#region Table-->
  @if (showTable) {
    <div>
      @if (company.additionalFields.length > 0) {
        <table class="is-fullwidth is-responsive table">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Description</th>
              <th scope="col">Type</th>
              <th scope="col">Parameters</th>
              <th scope="col">Packing&nbsp;Instruction?</th>
              <th scope="col">Private?</th>
              <th class="is-narrow"></th>
            </tr>
          </thead>
          <tbody>
            @for (
              additionalField of company.additionalFields;
              track additionalField
            ) {
              @if (additionalField.id !== deleteAdditionalFieldId) {
                <tr>
                  <td data-label="Name">{{ additionalField.name }}</td>
                  <td data-label="Description">
                    {{ additionalField.description | empty }}
                  </td>
                  <td data-label="Type">{{ additionalField.fieldType }}</td>
                  <td data-label="Parameters">
                    {{ additionalField.parameters | empty }}
                  </td>
                  <td data-label="Packing Instruction?">
                    @if (additionalField.isPackingInstruction) {
                      <svg-icon
                        class="text-green-500"
                        src="/assets/icons/general/check.svg"
                      />
                    }
                    @if (!additionalField.isPackingInstruction) {
                      <svg-icon
                        class="text-red-600"
                        src="/assets/icons/general/close.svg"
                      />
                    }
                  </td>
                  <td data-label="Private?">
                    @if (additionalField.private) {
                      <svg-icon
                        class="text-green-500"
                        src="/assets/icons/general/check.svg"
                      />
                    }
                    @if (!additionalField.private) {
                      <svg-icon
                        class="text-red-600"
                        src="/assets/icons/general/close.svg"
                      />
                    }
                  </td>
                  <td>
                    <div
                      class="field has-addons"
                      style="justify-content: flex-end"
                    >
                      <p class="control">
                        <button
                          class="button has-text-link is-small"
                          pTooltip="Edit"
                          tooltipPosition="top"
                          [disabled]="deletingAdditionalField"
                          (click)="showForm('Edit', additionalField)"
                        >
                          <svg-icon src="/assets/icons/general/edit.svg" />
                        </button>
                      </p>
                      <p class="control">
                        <button
                          class="button has-text-danger is-small"
                          pTooltip="Delete"
                          tooltipPosition="top"
                          [disabled]="deletingAdditionalField"
                          (click)="
                            showDeleteAdditionalField(additionalField.id)
                          "
                        >
                          <svg-icon src="/assets/icons/general/remove.svg" />
                        </button>
                      </p>
                    </div>
                  </td>
                </tr>
              }
              @if (additionalField.id === deleteAdditionalFieldId) {
                <tr>
                  <td colspan="6" class="has-text-right">
                    <div class="field has-addons" style="float: right">
                      <p class="control m-r-sm">
                        <span class="has-text-danger">
                          Delete <b>{{ additionalField.name }}</b
                          >?
                        </span>
                      </p>
                      <p class="control">
                        <button
                          class="button is-danger is-small"
                          (click)="deleteAdditionalField(additionalField)"
                          [ngClass]="{ 'is-loading': deletingAdditionalField }"
                          [disabled]="deletingAdditionalField"
                        >
                          <svg-icon src="/assets/icons/general/remove.svg" />
                          &nbsp; Delete
                        </button>
                      </p>
                      <p class="control">
                        <button
                          class="button is-default is-small"
                          (click)="deleteAdditionalFieldId = null"
                          [disabled]="deletingAdditionalField"
                        >
                          Cancel
                        </button>
                      </p>
                    </div>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      } @else {
        <ng-template [ngTemplateOutlet]="noAdditionalFields" />
      }
      <button
        class="button is-default is-fullwidth"
        style="justify-content: center"
        (click)="showForm('Add')"
      >
        <svg-icon src="/assets/icons/general/plus.svg" />
        &nbsp; Add field
      </button>
    </div>
  }
  <!--#endregion Table-->

  <!--#region Form-->
  @if (!showTable) {
    <form [formGroup]="additionalFieldForm">
      <div class="field">
        <label class="label">Name</label>
        <input
          required
          placeholder="..."
          class="input"
          [ngClass]="{
            'is-danger': formSubmitted && formControls.name.invalid,
          }"
          type="text"
          formControlName="name"
        />
        @if (formSubmitted && formControls.name.errors?.required) {
          <p class="help is-danger">Name is required</p>
        }
        @if (formSubmitted && formControls.name.errors?.existingColumn) {
          <p class="help is-danger">
            There is already a column named '{{
              formControls.name.errors?.existingColumn.value
            }}'
          </p>
        }
        @if (
          formSubmitted && formControls.name.errors?.existingAdditionalField
        ) {
          <p class="help is-danger">
            There is already an additional field named '{{
              formControls.name.errors?.existingAdditionalField.value
            }}'
          </p>
        }
      </div>
      <div class="field">
        <label class="label">Description</label>
        <input
          required
          class="input"
          placeholder="..."
          [ngClass]="{
            'is-danger': formSubmitted && formControls.description.invalid,
          }"
          type="text"
          formControlName="description"
        />
        @if (formSubmitted && formControls.description.errors?.required) {
          <p class="help is-danger">Description is required</p>
        }
      </div>
      <div class="field">
        <label class="label">Type</label>
        <div class="control">
          <div
            class="select is-fullwidth"
            [ngClass]="{
              'is-danger': formSubmitted && formControls.type.invalid,
            }"
          >
            <select required formControlName="type">
              <option value="text">Text</option>
              <option value="dropdown">Drop down</option>
              <option value="numeric">Numeric</option>
            </select>
          </div>
          @if (formSubmitted && formControls.type.errors?.required) {
            <p class="help is-danger">Type is required</p>
          }
        </div>
      </div>
      @if (["dropdown", "numeric"].includes(formControls.type.value)) {
        <div class="field">
          <label class="label">Parameters</label>
          <input
            required
            [ngClass]="{
              'is-danger': formSubmitted && formControls.parameters?.invalid,
            }"
            class="input"
            [type]="formControls.type.value === 'numeric' ? 'number' : 'text'"
            formControlName="parameters"
            [placeholder]="
              formControls.type.value === 'numeric'
                ? 'Please enter the number of decimal points'
                : 'Please enter a comma separated list of options'
            "
          />
          @if (formSubmitted && formControls.parameters.errors?.required) {
            <p class="help is-danger">Parameters is required</p>
          }
        </div>
      }
      <div class="field">
        <label class="label" for="packingInstruction">
          Packing Instruction
        </label>
        <p-toggleswitch
          inputId="packingInstruction"
          formControlName="packingInstruction"
        />
      </div>
      <div class="field">
        <label class="label" for="private">Private</label>
        <p-toggleswitch inputId="private" formControlName="private" />
      </div>
    </form>
  }
  <!--#endregion Form-->
</ag-modal-base>
